<!-- <h1>Angular Dynamic Meta Tags Example</h1>
 
<ul>
  <li><a [routerLink]="['/']">Home</a> </li>
  <li><a [routerLink]="['/first']">First</a> </li>
  <li><a [routerLink]="['/second']">Second</a> </li>
  <ul>
    <li><a [routerLink]="['/second/a']">Second A</a> </li>
  </ul>
  <li><a [routerLink]="['/third']">third</a> </li>
</ul>
<!-- <span><a [routerLink]="['/news']"></a></span> -->

<!-- <ng-progress direction=ltr+ speed=200 trickleSpeed=300 debounceTime=0 meteor=true spinner=true spinnerPosition=right -->
  <!-- thick=false fixed=true min=8 max=100 ease=linear color=red started=onStarted() completed=onCompleted()></ng-progress> -->
<router-outlet>

  <!-- <div style="position: relative"> -->
  <!-- <ngx-ui-loader [loaderId]="'loader-02'"></ngx-ui-loader> -->
  <!-- </div> -->
  <!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "large" color = "#fff" type = "ball-scale-multiple" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
</router-outlet>